import { render, staticRenderFns } from "./etf.vue?vue&type=template&id=a7165f3c"
import script from "./etf.vue?vue&type=script&lang=js"
export * from "./etf.vue?vue&type=script&lang=js"
import style0 from "./etf.vue?vue&type=style&index=0&id=a7165f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports